import React, { useState } from 'react';
import { RemoveLeadButtonProps } from './leadsModels';
import { RemoveIcon } from '../../../assets';
import { ConfirmModal, InfoModal } from '../../../components';
import { useAppData } from '../../../context/AppContext';
import {
  removeLeadById,
  removeLeadFromCampaign,
} from '../../../core/requests/requests';

const RemoveLeadButton: React.FC<RemoveLeadButtonProps> = ({
  leadId,
  refetchLeads,
  campaignId,
}) => {
  const { setShowModalBackground } = useAppData();
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');

  const handleShowConfirmLogoutModal = () => {
    setConfirmModalOpen(true);
    setShowModalBackground(true);
  };
  const handleCloseConfirmModal = () => {
    setConfirmModalOpen(false);
    setInfoMessage('');
    setShowModalBackground(false);
  };

  const handleRemoveLead = async () => {
    if (campaignId && leadId) {
      try {
        const { data } = await removeLeadFromCampaign(campaignId, leadId);
        if (data) {
          setConfirmModalOpen(false);
          setInfoMessage('Lead successfully removed from campaign!');
          setTimeout(() => {
            handleCloseConfirmModal();
            refetchLeads();
          }, 2000);
        }
      } catch (error) {
        console.log(error);
        setConfirmModalOpen(false);
        setInfoMessage('Error removing lead');
      }
    } else if (leadId) {
      try {
        const { data } = await removeLeadById(leadId);
        if (data) {
          setConfirmModalOpen(false);
          setInfoMessage('Lead removed successfully');
          setTimeout(() => {
            handleCloseConfirmModal();
            refetchLeads();
          }, 2000);
        }
      } catch (error) {
        console.log(error);
        setConfirmModalOpen(false);
        setInfoMessage('Error removing lead');
      }
    }
  };

  return (
    <>
      <button className="btn-icon" onClick={handleShowConfirmLogoutModal}>
        <RemoveIcon className="w-1_5rem" />
      </button>
      {isConfirmModalOpen && (
        <div className="d-flex-center p-fixed bg-modal top-0 left-0 size-max z4">
          <ConfirmModal
            title="Are you sure you want to remove this lead?"
            onConfirm={handleRemoveLead}
            onCancel={handleCloseConfirmModal}
          />
        </div>
      )}
      {infoMessage && (
        <div className="d-flex-center p-fixed bg-modal top-0 left-0 size-max z4">
          <InfoModal title={infoMessage} onClose={handleCloseConfirmModal} />
        </div>
      )}
    </>
  );
};

export default RemoveLeadButton;
